// @ts-strict-ignore
import { LineSegments, Material, Object3D, Vector3 } from 'three';
import { SimpleTextValueVO } from '@shared/vo/meta-element.vo';
import { DimensionUtils } from '../util/dimension.utils';
import { ILayerElement } from './i-layer-element';
import { LabelElement } from './label-element';

export class ArticlePositionElement extends Object3D implements ILayerElement {

    public static readonly LINE_COLOR_VALID: number = 0x03C03C;
    public static readonly LINE_COLOR_INVALID: number = 0xff0000;
    public static readonly LINE_LENGTH: number = 40;
    public static readonly LABEL_FONT_SIZE: number = 10;
    public static readonly LABEL_OFFSET: number = 30;

    public layerElementType: string = 'ILayerElement';
    private topPosition: Vector3;
    private bottomPosition: Vector3;
    private isValid: boolean;

    constructor(topPosition: Vector3, bottomPosition: Vector3, textValue: SimpleTextValueVO, isValid: boolean) {
      super();
      this.topPosition = topPosition;
      this.bottomPosition = bottomPosition;
      this.isValid = isValid;
      this.createLabels(textValue);
      this.createLine();
    }

    protected createLabels(textValue: SimpleTextValueVO): void {
      if (!textValue) {
        return;
      }
      const labelLength: number = DimensionUtils.getTextWidth(textValue, ArticlePositionElement.LABEL_FONT_SIZE);
      const topLabel: LabelElement = this.createLabel(textValue, labelLength);
      const bottomLabel: LabelElement = this.createLabel(textValue, labelLength);

      const topLabelPositionZ: number = this.topPosition.z + ArticlePositionElement.LABEL_OFFSET + ArticlePositionElement.LINE_LENGTH;
      const bottomLabelPositionZ: number = this.bottomPosition.z - ArticlePositionElement.LABEL_OFFSET - ArticlePositionElement.LINE_LENGTH;
      topLabel.position.set(this.topPosition.x, this.topPosition.y, topLabelPositionZ);
      bottomLabel.position.set(this.topPosition.x, this.topPosition.y, bottomLabelPositionZ);

      this.add(topLabel, bottomLabel);
    }

    protected createLabel(textValue: SimpleTextValueVO, labelLength): LabelElement {
      const label: LabelElement = new LabelElement(textValue, ArticlePositionElement.LABEL_FONT_SIZE, LabelElement.DEFAULT_ROTATION, labelLength);
      (label.material as Material).depthTest = true;
      label.renderOrder = 1;
      return label;
    }

    protected createLine(): void {
      const lines: Object3D = new Object3D();
      const startPoint: Vector3 = this.topPosition.clone().add(new Vector3(0, 0, ArticlePositionElement.LINE_LENGTH));
      const endPoint: Vector3 = this.bottomPosition.clone().add(new Vector3(0, 0, -ArticlePositionElement.LINE_LENGTH));
      const lineColor: number = this.isValid ? ArticlePositionElement.LINE_COLOR_VALID : ArticlePositionElement.LINE_COLOR_INVALID;
      const lineTo: LineSegments = DimensionUtils.createLineSegment(startPoint, endPoint, lineColor);
      lines.add(lineTo);
      this.add(lines);
    }
  }
